import { useEffect, useState, useMemo } from 'react';
import { breakpoints, isMobileViewport } from '../constants/responsive';

interface WindowSize {
  width: number;
  height: number;
  isMobile: boolean;
}

export const mobileBreakpoint = breakpoints.mobile;

/**
 * Custom hook that provides the current window size and a boolean flag indicating
 * whether the window width is below 769 pixels (indicating a mobile device).
 * @returns {object} An object containing width, height, and isMobile properties.
 */

const useWindowSize = (): WindowSize => {
  const [windowSize, setWindowSize] = useState<WindowSize>({
    width: window.innerWidth,
    height: window.innerHeight,
    isMobile: isMobileViewport(window.innerWidth)
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
        isMobile: isMobileViewport(window.innerWidth)
      });
    };

    // Add a listener to the window resize event
    window.addEventListener('resize', handleResize);

    // Remove the listener when the component unmounts
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const memoizedWindowSize = useMemo(() => {
    return windowSize;
  }, [windowSize]);

  return memoizedWindowSize;
};

export default useWindowSize;
